import { createContext, useContext } from 'react'
import ActivityStore from './activityStore'
import AdminStore from './adminStore'
import BlogStore from './blogStore'
import CommonStore from './commonStore'
import FirearmStore from './firearmStore'
import FirearmModelStore from './firearmModelStore'
import ModalStore from './modalStore'
import PartStore from './partStore'
import ProfileStore from './profileStore'
import UserStore from './userStore'
import VoteStore from './voteStore'
import BuildStore from './buildStore'
import TagStore from './tagStore'
import ModerationStore from './moderationStore'
import NotificationStore from './notificationStore'
import FeedStore from './feedStore'
import GunVaultStore from './gunVaultStore'
import WishlistStore from './wishlistStore'
import NavigationStore from './navigationStore'
import SlopFeedStore from './slopFeedStore'
import EditorStore from './EditorStore'
import UploadDrawerStore from './uploadDrawerStore'

interface Store {
    activityStore: ActivityStore;
    adminStore: AdminStore;
    blogStore: BlogStore;
    commonStore: CommonStore;
    firearmStore: FirearmStore;
    firearmModelStore: FirearmModelStore;
    partStore: PartStore;
    userStore: UserStore;
    voteStore: VoteStore;
    buildStore: BuildStore;
    modalStore: ModalStore;
    profileStore: ProfileStore;
    tagStore: TagStore;
    moderationStore: ModerationStore;
    notificationStore: NotificationStore;
    feedStore: FeedStore;
    gunVaultStore: GunVaultStore;
    wishlistStore: WishlistStore;
    navigationStore: NavigationStore;
    slopFeedStore: SlopFeedStore;
    editorStore: EditorStore;
    uploadDrawerStore: UploadDrawerStore;
}

const editorStore = new EditorStore()

export const store: Store = {
  activityStore: new ActivityStore(),
  adminStore: new AdminStore(),
  blogStore: new BlogStore(),
  commonStore: new CommonStore(),
  firearmStore: new FirearmStore(),
  firearmModelStore: new FirearmModelStore(),
  partStore: new PartStore(),
  userStore: new UserStore(),
  voteStore: new VoteStore(),
  buildStore: new BuildStore(),
  modalStore: new ModalStore(),
  profileStore: new ProfileStore(),
  tagStore: new TagStore(),
  moderationStore: new ModerationStore(),
  notificationStore: new NotificationStore(),
  feedStore: new FeedStore(),
  gunVaultStore: new GunVaultStore(),
  wishlistStore: new WishlistStore(),
  navigationStore: new NavigationStore(),
  slopFeedStore: new SlopFeedStore(),
  editorStore,
  uploadDrawerStore: new UploadDrawerStore(editorStore)
}

export const StoreContext = createContext(store)

export function useStore () {
  return useContext(StoreContext)
}
